import { Component, computed } from '@angular/core';
import { JSBridgeService } from '../../core/jsbridge.service';
import { wasmMapForEach, wasmVectorForEach, wasmVectorToArray } from '../../utils/wasmVector';
import { KopConfigService } from '../../core/kop-config.service';
import { cKC_Afdeling, cKC_LosDefs, JSBridge } from '@wasm/KopWeb';
import { AfdMeta, MetaService } from '../../core/meta.service';
import { KanaalService } from '../../kanaal/kanaal.service';
import { kanaalLabel } from '../../kanaal/kanaal.utils';
import { AnalogIn } from '../../props/PropTypes';

type LosDefInfo = {
  index: number,
  waarde: number,
  range: number,
  omschr: string,
  versionTm: string
};

type AIInfo = {
  index: number,
  kanaal: number,
  range: number,
  omschr: string,
  versionTm: string;
};


type KopInfoType = {
  name: string,
  type: string,
  validInArm: string,
  validTm: string,
  refnr: number,
  losdefs: Array<LosDefInfo>,
  droogWands: Array<LosDefInfo>,
  koelings: Array<LosDefInfo>,
  verwarmings: Array<LosDefInfo>,
  ais: Array<AIInfo>,
  servos: Array<AIInfo>,
  bijzPrgms: Array<AIInfo>
  
};

@Component({
  selector: 'legacy-info',
  templateUrl: './legacy-info.component.html',
  styleUrl: './legacy-info.component.scss'
})
export class LegacyInfoComponent {

  constructor(public jsBridgeService: JSBridgeService, public kopConfigService: KopConfigService, public metaService: MetaService, private kanaalService: KanaalService) {
    jsBridgeService.getBridge().subscribe(bridge => {
      this.jsBridge = bridge;
      let cfg = this.jsBridge.getModuleConfig();
      console.log(cfg);
      this.buildAfdelingsInfo();
    });

  }
  private jsBridge: JSBridge | undefined;

  public kopInfo: KopInfoType[] = [];

  private buildLosDefs(losDefs: cKC_LosDefs, meta: AfdMeta) {
    let losdefs: Array<LosDefInfo> = [];
    wasmVectorForEach(losDefs, ld => {
      let ldMeta = meta.losDefRaw.find(ldm => ldm.index == ld.index);
      if (ld.waarde == 0) {
        return;
      }
      losdefs.push({
        index: ld.index,
        waarde: ld.waarde,
        range: ld.range,
        omschr: ldMeta != undefined ? ldMeta.omschr.toString() : "NOT FOUND",
        versionTm: ldMeta != undefined ? ldMeta!.versieTm.toString().trim() : "NOT FOUND"
      });
    });

    return losdefs;

  }

  public label(kanaal: number) {
    return kanaalLabel(kanaal, AnalogIn);
  }

  private buildAfdelingsInfo() {
    let afdelings = this.kopConfigService.afdelings();
    let ret: KopInfoType[] = [];
    for (let afdWM of afdelings) {
      let afd = afdWM.afdeling();
      let meta = this.metaService.afdelingMeta(afd);
      let afdTMMeta = this.afdMeta(afd);
      let typeName = this.getTypeName(afd);
      let validInArm = this.validInArm(afd);
      let losdefs: Array<LosDefInfo> = this.buildLosDefs(afd.losDefs, meta);

      let droogWand: Array<LosDefInfo> = this.buildLosDefs(afd.droogWand, meta);
      let koelings: Array<LosDefInfo> = this.buildLosDefs(afd.koeling, meta);
      let verwarmings: Array<LosDefInfo> = this.buildLosDefs(afd.verwarming, meta);

      let ais: AIInfo[] = [];

      wasmVectorForEach(afd.analogs, ai => {
        let aiMeta = meta.ais.find(m => m.index == ai.index);
        if (ai.kanaal == 0) {
          return;
        }
        ais.push({
          index: ai.index,
          kanaal: ai.kanaal,
          range: ai.range,
          omschr: aiMeta != undefined ? aiMeta.omschrij.toString() : "NOT FOUND",
          versionTm: aiMeta != undefined ? aiMeta.versieTm.toString().trim() : "NOT FOUND"
        })
        
      });

      let servos:AIInfo[] = [];
      wasmVectorForEach(afd.servos, servo => {
        let servoMeta = meta.servos.find(m => m.index == servo.index);
        let kanaalType = this.kanaalService.getServoKanaalType({ soort: servo.soort.value, uitgang: servo.uitgang, stationnr: servo.stationnr, modbusNetworkId: servo.modbusNetworkId });
        if (servo.uitgang == 0) {
          return;
        }

        servos.push({
          index: servo.index,
          kanaal: servo.uitgang,
          range: kanaalType?.range ?? 0,
          omschr: servoMeta != undefined ? servoMeta.omschr.toString() : "NOT FOUND",
          versionTm: servoMeta != undefined ? servoMeta.versieTm.toString().trim() : "NOT FOUND"
        })
      });


      let bijzPrgs:AIInfo[] = [];
      wasmVectorForEach(afd.bijzPrgs, bp => {
        let bpMeta = meta.bijzPrgs.find(m => m.index == bp.index);

        bijzPrgs.push({
          index: bp.index,
          kanaal: 0,
          range: 0,
          omschr: bpMeta != undefined ? bpMeta.omschr.toString() : "NOT FOUND",
          versionTm: bpMeta != undefined ? bpMeta.versieTm.toString().trim() : "NOT FOUND"
        })
      });

      ret.push({
        name: afd.titel.toString(),
        type: typeName,
        validInArm: validInArm,
        validTm: afdTMMeta?.versieTm.toString() ?? "",
        refnr: afd.refNr,
        losdefs: losdefs,
        droogWands: droogWand,
        koelings: koelings,
        verwarmings: verwarmings,
        ais: ais,
        servos: servos,
        bijzPrgms: bijzPrgs
      })
    }

    this.kopInfo = ret;
  } 

  public allAfd = computed(() => {
    let tmp = this.jsBridgeService.getBridgeSync().getAfdelingsInfo();
    let ret = wasmVectorToArray(tmp);
    tmp.delete();
    return ret;
  });

  public typeMap = computed(() => {
    let wasmModule = this.jsBridgeService.wasmModule;
    if (wasmModule == undefined) return {};
    let t = Object.entries(wasmModule.eAfdelingType).map(([key, value]) => {
      return [value.value, key];
    });
    let map = Object.fromEntries(t);
    return map;
  });

  public getTypeName(afd: cKC_Afdeling) {
    return this.typeMap()[afd.type.value];
  }

  public afdMeta(afd: cKC_Afdeling) {
    let allAfd = this.allAfd();
    let ret = allAfd.filter(a => a.type == afd.type.value);
    if (ret.length == 0) {
      return undefined;
    }
    return ret[0];
  }

  public validInArm(afd: cKC_Afdeling) {
    let allAfd = this.allAfd();
    let ret = allAfd.filter(a => a.type == afd.type.value);
    if (ret.length == 0) {
      return "N/A";
    }
    let afdInfo = ret[0];
    let endVersion = afdInfo.versieTm.toString();
    if (endVersion == "") {
      return "Valid";
    }
    return endVersion;

  }



}
